import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import SectionHeader from "../../components/ui/HeaderSection";
import bgBundle from "../../assets/images/bg-bundle.png";
import { FaCheckCircle } from "react-icons/fa";
import Button from "../../components/ui/Button";

const plans = [
  {
    name: "Basic",
    price: "Free",
    buttonText: "Akses Sekarang",
    textColor: "#0B73E2",
    bgColor: "#B7D7F8",
    buttonColor: "#007BFF",
  },
  {
    name: "Premium",
    price: "Rp 30.000",
    buttonText: "Beli",
    textColor: "#EC7C65",
    bgColor: "#FFD4CB",
    buttonColor: "#27AE60",
    badge: {
      text: "BEST VALUE",
      bgColor: "#F9BDB1",
      icon: "★",
    },
  },
  {
    name: "VIP",
    price: "Rp 50.000",
    buttonText: "Beli",
    textColor: "#DC8E01",
    bgColor: "#FFF6E5",
    buttonColor: "#27AE60",
    badge: {
      text: "ULTIMATE EXPERIENCE",
      bgColor: "#FFE3AF",
      icon: "👑",
    },
  },
];

const BundleSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section
      id="bundle-section"
      className="relative py-16 px-6 md:px-10 text-center"
      style={{
        backgroundImage: `url(${bgBundle})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "repeat-y",
        minHeight: "100vh",
      }}
    >
      {/* Konten utama */}
      <div className="relative z-10 flex flex-col items-center">
        {/* Header tanpa efek AOS */}
        <div data-aos="fade-up" data-aos-duration="1000">
          <SectionHeader
            title="Tentukan Paketmu"
            description="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            TitleColor="#FFFFFF"
            DescriptionColor="#FFFFFF"
          />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 max-w-3xl w-full mx-auto mt-12">
          {plans.map((plan, index) => (
            <div
              key={index}
              data-aos="fade-up"
              className="relative bg-white rounded-lg shadow-md p-6 flex flex-col items-center transform transition-all duration-500 ease-in-out hover:-translate-y-4 hover:shadow-2xl"
              style={{
                borderRadius: "8px",
                fontFamily: "Montserrat, sans-serif",
              }}
            >
              {/* Badge */}
              {plan.badge && (
                <div
                  className="absolute top-0 right-0 px-3 py-2 text-xs font-bold text-[#964E3E] flex items-center gap-2"
                  style={{
                    backgroundColor: plan.badge.bgColor,
                    borderRadius: "0px 8px 0px 40px",
                    fontSize: "10px",
                    fontFamily: "Montserrat, sans-serif",
                    textTransform: "uppercase",
                  }}
                >
                  <span>{plan.badge.icon}</span> {plan.badge.text}
                </div>
              )}
              {/* Title */}
              <div
                className="px-8 py-1.5 mt-6 font-semibold text-lg"
                style={{
                  color: plan.textColor,
                  backgroundColor: plan.bgColor,
                  borderRadius: "26px",
                  fontSize: "14px",
                  fontWeight: "semibold",
                }}
              >
                {plan.name}
              </div>
              {/* Price */}
              <p className="text-lg font-semibold text-[#E98362] mt-5">
                {plan.price}
              </p>
              {/* Button */}
              <Button
                text={plan.buttonText}
                className="mt-4 px-6 py-2 text-white font-semibold rounded-md w-full hover:opacity-90 transition-all duration-300"
                style={{
                  backgroundColor: plan.buttonColor,
                  borderRadius: "8px",
                }}
              />
              {/* Divider */}
              <hr className="w-full border-t border-gray-300 my-8" />
              {/* Features */}
              <ul className="mt-0 space-y-3 text-[#49516F] text-xs w-full pb-20">
                <li className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500" />
                  Lorem Ipsum is simply
                </li>
                <li className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500" />
                  Lorem Ipsum is simply
                </li>
                <li className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500" />
                  Lorem Ipsum is simply
                </li>
                <li className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500" />
                  Lorem Ipsum is simply
                </li>
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BundleSection;
